import { render, staticRenderFns } from "./SelectTypeSchoolLevelDashboard.vue?vue&type=template&id=1ead4547&scoped=true&"
import script from "./SelectTypeSchoolLevelDashboard.vue?vue&type=script&lang=js&"
export * from "./SelectTypeSchoolLevelDashboard.vue?vue&type=script&lang=js&"
import style0 from "./SelectTypeSchoolLevelDashboard.vue?vue&type=style&index=0&id=1ead4547&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ead4547",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VIcon,VList,VListItem,VListItemTitle,VMenu})
